import React from "react";
import {Button} from "react-bootstrap";
import {withNamespaces} from "react-i18next";
import {Link} from "react-router-dom";
import {modalActions} from "../../../../actions/modal.actions";
import {connect} from "react-redux";
import {networkDeviceContentActions} from "../../../../actions/network-device-content.actions";
import {claimTypes} from "../../../../constants/claim.constants";
import NetworkDeviceContentCopyForm from "../_forms/NetworkDeviceContentCopyForm";

const NetworkDeviceContentActionButtons = ({t, user, row, device, hideModal, showModal, removeContent, copyContent}) => {

    const networkDeviceContentCrud      = user[`c_network-device-content.actions.crud`] || null;
    const networkDeviceContentSyncRetry = user[`c_network-device-content.actions.sync-retry`] || null;

    const linkToDownload = "/api/networkdevicescontent/getfile/" + row.id;

    const openModalRemove = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${model.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: model.id,
            confirmAction: () => {
                removeContent(row.id, device.id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const openModalCopy = (model) => {
        showModal({
            open: true,
            title: t('copy-content'),
            component: <NetworkDeviceContentCopyForm content={model} submit={(model) => submitModalCopy(model)} closeModal={() => closeModal()} />
        }, 'formModal');
    };

    const submitModalCopy = (copyModel) => {
        copyContent(copyModel);
    }

    const closeModal = () => {
        hideModal();
    };


    return  (
        <React.Fragment>
            { device?.diagnosticMode ? (
                <div>
                    <Button className="mx-1" variant="warning" onClick={() => openModalCopy(row)}>
                        <i className="fas fa-copy"/>
                    </Button>

                    { networkDeviceContentCrud === claimTypes.READ_WRITE ? (
                        <Link to={`/panel/network-device/content/${device.id}/edit/${row.id}`}>
                            <Button className="mx-1" variant={"primary"} >
                                <i className="fas fa-edit" />
                            </Button>
                        </Link>
                    ) : (<React.Fragment/>) }

                    { networkDeviceContentCrud === claimTypes.READ_WRITE ? (
                        <Button className="mx-1" variant={"danger"}  onClick={() => openModalRemove(row)} >
                            <i className="fas fa-trash" />
                        </Button>
                    ) : (<React.Fragment/>) }

                    { networkDeviceContentCrud !== claimTypes.NONE ? (
                        <Link to={linkToDownload} target="_blank" download>
                            <Button className="mx-1" variant={"outline-success"} download>
                                <i className="fas fa-download"/>
                            </Button>
                        </Link>
                    ) : (<React.Fragment/>) }

                </div>
            ) : (
                <div>
                    { networkDeviceContentCrud !== claimTypes.NONE ? (
                        <Link to={linkToDownload} target="_blank" download>
                            <Button className="mx-1" variant={"outline-success"} download>
                                <i className="fas fa-download"/>
                            </Button>
                        </Link>
                    ) : (<React.Fragment/>) }
                </div>
            ) }

            { networkDeviceContentCrud === claimTypes.NONE && networkDeviceContentSyncRetry !== claimTypes.READ_WRITE ? (
                t('msg.not-permission')
            ) : (
                <React.Fragment/>
            ) }

        </React.Fragment>
    )
};

const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

const mapDispatchToProps = (dispatch) => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    },
    removeContent: (contentId, deviceId) => dispatch(networkDeviceContentActions.removeContent(contentId, deviceId)),
    retryContent: (contentId, deviceId) => dispatch(networkDeviceContentActions.retryContent(contentId, deviceId)),
    copyContent: (contentModel) => dispatch(networkDeviceContentActions.copyContent(contentModel))
});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(NetworkDeviceContentActionButtons));
